//import '@babel/polyfill';
import '@/scss/app.scss'
import 'bootstrap';

if (module.hot) {
  module.hot.accept()
}
